export default "__VITE_ASSET__e37b7b06__"